/* eslint-disable import/prefer-default-export */
import { createSlice } from '@reduxjs/toolkit';

const teamsSlice = createSlice({
  name: 'teams',
  initialState: {
    null: {},
  },
  reducers: {
    setTeams: (state, { payload }) => {
      const ts = payload.reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {});
      return { ...state, ...ts };
    },
  },
});

export const { setTeams } = teamsSlice.actions;

export default teamsSlice.reducer;
